<template >
  <base-dialog-form :type="type" ref="editConsiglioDialog" :title="computedTitle" color="secondary"
    icon="mdi-account-group" v-if="RBAC_USER_VIEW_OTHER_USER">
    <template v-slot:actions>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="editable" @click="addExecutive" color="primary">{{ $t("add_executive") }}</v-btn>
          <v-btn class="mx-5" v-if="editable" @click="saveConsiglio" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="editable && ifNew" @click="undoConsiglio" color="error">{{ $t("undo") }}</v-btn>
          <v-btn class="mx-5" v-if="editable && !ifNew" @click="deleteConsiglio" color="error">{{ $t("delete") }}</v-btn>

          <v-btn class="mx-5" v-if="method === 'APPROVE' && ifEnte && toApprove" @click="approveModify" color="success">{{
            $t("approve") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'APPROVE' && ifEnte && toApprove" @click="rejectModify" color="error">{{
            $t("reject") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container fluid tag="section">
        <v-row no-gutters>
          <v-col class="d-flex justify-center" offset-md="3" md="3" cols="12">
            <v-select v-model="selectedConsiglio" @change="loadData()" :items="listConsigli"
              :menu-props="{ maxHeight: '400' }" :label="$t('date_council')" required color="primary"
              persistent-hint></v-select>
          </v-col>
          <v-col class="d-flex justify-center" md="3" cols="12">
            <v-btn class="mx-5" v-if="!ifEnte || method !== 'APPROVE'" @click="createNewConsiglio" color="success">{{
              $t("create_new_council") }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row>
          <v-col v-if="toApprove" cols="12" class="text-center">
            <v-banner single-line>
              <v-icon slot="icon" color="warning" size="36">mdi-alert-outline</v-icon>
              <h2 class="warning--text">
                {{ $t("data_waiting_for_approvation") }}
              </h2>
            </v-banner>
          </v-col>
        </v-row>
        <v-card outlined v-if="currentConsiglio.members && currentConsiglio.members.length > 0">
          <v-card-title>
            <v-icon slot="icon" color="primary" size="36">mdi-account-group</v-icon>
            <my-datepicker v-if="ifNew" v-model="currentConsiglio.dateEmi" :label="$t('date')" required="true" />
            <h4 v-else style="margin-left: 10px" class="primary--text">
              {{ new Date(currentConsiglio.dateEmi).toLocaleDateString() }}
            </h4>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead>
                <tr>
                  <td>Ruolo</td>
                  <td>Persona</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="membro in currentConsiglio.members" v-bind:key="membro.id">
                  <td>
                    {{ $t(membro.role) }}
                    <v-btn class="mx-5" v-if="editable && membro.role === 'executive'"
                      @click.native="removeExecutive(membro)" color="error" text>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                  <td v-if="editable">
                    <v-autocomplete v-model="membro.masterId" :items="listUsers" :menu-props="{ maxHeight: '400' }"
                      :label="$t('user')" required color="primary" persistent-hint></v-autocomplete>
                  </td>
                  <td v-else>{{ membro.surname }} {{ membro.name }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "edit-consiglio",
  props: {
    parmsMethod: null,
    parmsAsdCode: null,
    parmsMode: null,
    type: {
      type: String, // not 'string'
      required: false,
      default: "dialog",
    },
  },
  components: {
    MyDatepicker,
  },
  computed: {
    editable: function () {
      if (
        this.currentConsiglio.status === 0 &&
        (this.isNew || this.method === "ADD" || this.method === "EDIT")
      )
        return true;
      else return false;
    },
    computedTitle: function () {
      if (this.method === "APPROVE" && this.toApprove)
        return this.$t("approve_council");
      else if (this.method === "APPROVE" && !this.toApprove)
        return this.$t("view_council");
      else if (this.method === "EDIT") return this.$t("manage_council");
      else if (this.method === "VIEW") return this.$t("view_council");
      else if (this.method === "ADD") return this.$t("create_new_council");
      else return "";
    },
  },
  data() {
    return {
      method: null,
      code: null,
      mode: null,
      ifNew: false,
      listConsigli: [],
      listUsers: [],
      currentConsiglio: [],
      selectedConsiglio: null,
      valid: false,
      ifEnte: false,
      toApprove: null,
      RBAC_USER_VIEW_OTHER_USER: false,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, code) {
      this.method = method;
      this.code = code;
      this.loadData();
      this.$refs.editConsiglioDialog.open();
    },
    addExecutive() {
      this.currentConsiglio.members.push({
        role: "executive",
        id: this.currentConsiglio.length,
        masterId: null,
        name: null,
        surname: null,
      });
    },
    removeExecutive(item) {
      this.currentConsiglio.members = this.currentConsiglio.members.filter(
        (membro) => {
          return membro.masterId !== item.masterId;
        }
      );
    },
    createNewConsiglio() {
      this.ifNew = true;
      this.currentConsiglio.status = 0;
      this.currentConsiglio.dateEmi = new Date();
      this.currentConsiglio.members = [
        {
          role: "president",
          id: 0,
          masterId: null,
          name: null,
          surname: null,
        },
        {
          role: "secretary",
          id: 1,
          masterId: null,
          name: null,
          surname: null,
        },
        {
          role: "treasurer",
          id: 2,
          masterId: null,
          name: null,
          surname: null,
        },
      ];
    },
    undoConsiglio() {
      this.selectedConsiglio = null;
      this.loadData();
    },
    loadData() {
      let _ = this;
      _.ifNew = false;
      let code = systemData.ASD.code;
      if (_.code) code = _.code;
      _.listConsigli = [];
      _.chiamataAxios("GET", "/auth/ente/listConsigli/" + code).then(
        (response) => {
          response.data.forEach((consiglio) => {
            let obj = {
              value: consiglio.dateEmi,
              text:
                new Date(consiglio.dateEmi).toLocaleDateString() +
                (consiglio.status === 0 ? " (" + _.$t("to_approve") + ")" : ""),
            };
            _.listConsigli.push(obj);
          });
          if (!_.selectedConsiglio && _.listConsigli.length > 0)
            _.selectedConsiglio = _.listConsigli[0].value;

          _.currentConsiglio = [];
          _.toApprove = false;
          _.chiamataAxios(
            "GET",
            "/auth/ente/getConsiglio/" + code + "/" + _.selectedConsiglio
          ).then((response) => {
            if (response.data.status === 0) _.toApprove = true;
            _.currentConsiglio = response.data;
            _.currentConsiglio.members = _.currentConsiglio.members.map(
              (membro) => {
                membro.id = membro.masterId;
                return membro;
              }
            );
          });
        }
      );
    },

    approveModify(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_approve"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "PUT",
            "/auth/ente/approveConsiglio/" +
            _.code +
            "/" +
            _.currentConsiglio.dateEmi,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + _.$t("data_approved") + "</strong>";
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    rejectModify(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_reject"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/ente/rejectConsiglio/" +
            _.code +
            "/" +
            _.currentConsiglio.dateEmi,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    deleteConsiglio(item) {
      let _ = this;

      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/ente/deleteConsiglio/" + _.selectedConsiglio,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.selectedConsiglio = null;
              _.loadData();
              _.$emit("isUpdated", "true");
            }
          });
        }
      });
    },
    saveConsiglio: function () {
      let _ = this;
      _.chiamataAxios("PUT", "/auth/ente/saveConsiglio/", {
        dialogLoader: true,
        body: _.currentConsiglio,
      }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$refs.editConsiglioDialog.close();
          _.loadData();
          _.$emit("isUpdated", "true");
        }
      });
    },
  },
  created() {
    let _ = this;
    _.listUsers = [];
    _.RBAC_USER_VIEW_OTHER_USER = this.checkUserRole("user", "VIEW_OTHER_USER");
    if (_.RBAC_USER_VIEW_OTHER_USER)
      _.chiamataAxios("POST", "/auth/portal/listUsers", {
        body: { filter: {} },
      }).then((response) => {
        _.listUsers = response.data.map(function (item) {
          return {
            value: item.masterId,
            text: item.surname + " " + item.name,
          };
        });
      });
  },
  mounted() {
    this.ifEnte = window.systemData.ifEnte;
    if (this.parmsAsdCode) this.code = this.parmsAsdCode;
    if (this.parmsMethod) this.method = this.parmsMethod;
    if (this.parmsMode) this.mode = this.parmsMode;
    this.loadData();
  },
  watch: {
    parmsAsdCode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.code = newVal;
    },
    parmsMethod: function (newVal, oldVal) {
      // watch it
      if (newVal) this.method = newVal;
    },
    parmsMode: function (newVal, oldVal) {
      // watch it
      if (newVal) this.mode = newVal;
    },
    code: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>